import { render, staticRenderFns } from "./CutConfigList.vue?vue&type=template&id=56ef8d64&"
import script from "./CutConfigList.vue?vue&type=script&lang=js&"
export * from "./CutConfigList.vue?vue&type=script&lang=js&"
import style0 from "./CutConfigList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports